<template>
  <Section id="lead-magnet" tone="default" pad-y="md">
    <Container>
      <LeadMagnet
        :heading="t('sections.leadMagnet.title')"
        :description="t('sections.leadMagnet.description')"
        :file-label="t('sections.leadMagnet.fileLabel')"
        :cta-label="t('cta.getCaseBook')"
        @submit="submitForm"
      />
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import LeadMagnet from '@/components/domain/LeadMagnet.vue';
import { sendBafsyLetter, sendUserLetter } from '@/helpers/notificationMethods';
import { yaTrackEvent } from '@/lib/metrics';

const { t } = useI18n();

const submitForm = (payload: { email: string }) => {
  yaTrackEvent('NewSiteRequestBookcases');
  sendBafsyLetter('bookCases', payload);
  sendUserLetter('bookCases', payload.email);
};
</script>
